import {
	ExtendedTopSearchItemModeWithSearchInput,
	TopSearchDropdownItemMode,
} from '@/new-top-search/top-search-dropdown-item/top-search-dropdown-item.types';

export interface ITopSearchConfig {
	id: TopSearchDropdownItemMode;
	text: string;
	isInput?: boolean;
	iconClass?: string;
}

export interface ITopSearchAdvancedConfig {
	id: TopSearchDropdownItemMode | ExtendedTopSearchItemModeWithSearchInput;
	text: string;
}

export const TopSearchMainConfig: ITopSearchConfig[] = [
	{
		id: TopSearchDropdownItemMode.SEARCH,
		text: 'Szukaj',
	},
	{
		id: TopSearchDropdownItemMode.LOCATIONS,
		text: 'Kierunek',
		iconClass: 'fa-solid fa-location-dot',
	},
	{
		id: TopSearchDropdownItemMode.DATE_RANGE,
		text: 'Data',
		iconClass: 'fa-regular fa-calendar',
	},
	{
		id: TopSearchDropdownItemMode.STOPS,
		text: 'Transport',
		iconClass: 'fa-solid fa-plane',
	},
	{
		id: TopSearchDropdownItemMode.PARTICIPANTS,
		text: 'Uczestnicy',
		iconClass: 'fa-solid fa-user-group',
	},
];

export const TopSearchMainConfigWithoutSearch: ITopSearchConfig[] = TopSearchMainConfig.filter(
	(item) => item.id !== TopSearchDropdownItemMode.SEARCH,
);

export const TopSearchAdvancedConfig: ITopSearchConfig[] = [
	{
		id: TopSearchDropdownItemMode.KINDS,
		text: 'Rodzaj wycieczki',
	},
	{
		id: TopSearchDropdownItemMode.BOARDS,
		text: 'Wyżywienie',
	},
	{
		id: TopSearchDropdownItemMode.NIGHTS,
		text: 'Liczba noclegów',
	},
	{
		id: TopSearchDropdownItemMode.PRICE,
		text: 'Cena',
		iconClass: 'fa-solid fa-tag',
	},
	{
		id: TopSearchDropdownItemMode.CONVENIENCES,
		text: 'Udogodnienia',
	},
];

export const TopSearchMobileDialogConfig: ITopSearchConfig[] = [
	...TopSearchMainConfigWithoutSearch,
	...TopSearchAdvancedConfig,
];

export const ExtendedTopSearchAdvancedSearchConfig = [
	{
		id: ExtendedTopSearchItemModeWithSearchInput.SEARCH,
		text: 'Wyszukaj',
	},
];

export const TopSearchHeaderConfig: ITopSearchAdvancedConfig[] = [
	...TopSearchMainConfig,
	...TopSearchAdvancedConfig,
	...ExtendedTopSearchAdvancedSearchConfig,
];
